import React, { createContext, useState, useContext, useMemo } from 'react';

// Create the context
const IsEditedContext = createContext(null);

// Create a provider component
export const IsEditedProvider = ({ children }) => {
    const [isEdited, setIsEdited] = useState(false);

    // Memorize the context value to avoid unnecessary re-renders
    const value = useMemo(() => ({ isEdited, setIsEdited }), [isEdited]);

    return (
        <IsEditedContext.Provider value={value}>
            {children}
        </IsEditedContext.Provider>
    );
};

// Custom hook to use the IsEditedContext
export const useIsEdited = () => {
    const context = useContext(IsEditedContext);
    if (!context) {
        throw new Error("useIsEdited must be used within an IsEditedProvider");
    }
    return context;
};
